import React, { Component } from "react";
import "../../Page/Dashboard/index.css";
import "../index.css";
import "./index.css";
import TopMenu from "../Layout/TopMenu";
import MenuDesktop from "../Layout/MenuDesktop";
import Footer from "../Layout/Footer";
import { MDBRow, MDBCol } from "mdbreact";
import { IoSearch } from "react-icons/io5";
import { NavLink, withRouter } from "react-router-dom";
import {
  RiArrowDownSLine,
  RiArrowUpSLine,
  RiArrowRightSLine,
} from "react-icons/ri";
import NavBar from "../Layout/NavBar";
import mixpanel from "mixpanel-browser";
import { HiLightningBolt, HiSortAscending } from "react-icons/hi";

import { firebase } from "../../../firebase/config";

import { TiTick } from "react-icons/ti";
import VisibilitySensor from "react-visibility-sensor";
import Scroll from "react-scroll";
import FAQ from "../FAQ";

class Intro extends Component {
  constructor(props) {
    super(props);

    this.state = {
      querySellers: [],
    };
  }

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  openModal = () => {
    this.setState({ signUp: true, isNavbar: false });
  };

  componentDidMount() {
    firebase
      .firestore()
      .collection("sellers")
      .orderBy("level", "desc")
      .limit(6)
      .get()
      .then((querySnapshot) => {
        let empty = [];
        querySnapshot.forEach((doc) => {
          empty.push(doc.data());
        });
        this.setState({ sellers: empty, querySellers: empty });
      });
  }

  render() {
    console.log(this.props.version);
    return (
      <>
        <MDBCol
          className="backy26"
          style={{
            width: "100vw",
            overflowX: "hidden",
            color: "white",
          }}
          size="12"
        >
          <MDBRow className="HeroSection">
            <MenuDesktop color="light" />
            <MDBCol size="12">
              <MDBRow style={{ paddingBottom: "5vh" }}>
                <MDBCol className="d-flex justify-content-center" size="12">
                  <p
                    style={{
                      fontFamily: "PlusJSMedium",
                      fontSize: 13,
                      marginTop: 40,
                      textAlign: "center",
                      opacity: 1,
                      color: "#FF0000",
                    }}
                  >
                    PRICING
                  </p>
                </MDBCol>
                <MDBCol
                  style={{ color: "white", marginTop: -30 }}
                  className="d-flex justify-content-center"
                  size="12"
                >
                  <p className="HeroHeading">
                    Custom pricing designed
                    <br />
                    for your Youtube Channel
                  </p>
                </MDBCol>
                <MDBCol className="d-flex justify-content-center" size="12">
                  <p style={{ color: "white" }} className="HeroSubHeading">
                    Rather than setting the same price for everyone, we work
                    <br />
                    with you to decide a price that fits your requirements.
                  </p>
                </MDBCol>

                <MDBCol className="d-flex justify-content-center" size="12">
                  <a
                    href=""
                    target="_blank"
                    className="d-flex  justify-content-center"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    <div
                      className="d-flex  HeroButton lightButton justify-content-center"
                      style={{
                        backgroundColor: "#FF0000",
                        borderRadius: 200,
                        paddingTop: 13,
                        color: "white",
                        fontFamily: "PlusJSBold",
                        fontSize: 15,
                        width: 170,
                        height: 49,
                        marginTop: 10,
                        display: "inline-block",
                      }}
                    >
                      Book a Demo
                    </div>
                  </a>
                </MDBCol>
                <MDBCol
                  style={{ marginTop: 10 }}
                  className="d-flex justify-content-center"
                  size="12"
                >
                  <p
                    style={{
                      fontFamily: "PlusJSMedium",
                      color: "white",
                      fontSize: 12,
                      marginTop: 5,
                      textAlign: "center",
                      opacity: 1,
                    }}
                  >
                    Have questions?{" "}
                    <a
                      href="mailto:help@youdub.me"
                      style={{
                        display: "inline-block",
                        textDecoration: "underline",
                        color: "#FF0000",
                      }}
                    >
                      {" "}
                      Contact us
                    </a>
                  </p>
                </MDBCol>
              </MDBRow>
            </MDBCol>
          </MDBRow>

          <MDBRow
            style={{
              height: 360,
              backgroundColor: "#F5F5F5",
              color: "black",
              width: "100vw",
            }}
          >
            <MDBCol size="4">
              <p
                style={{
                  fontFamily: "PlusJSExtraBold",
                  fontSize: 25,
                  marginTop: 95,
                  lineHeight: 1.3,
                  width: "100%",
                  marginLeft: 45,
                }}
              >
                Suitable for all sizes
              </p>
              <p
                style={{
                  fontFamily: "PlusJSMedium",
                  color: "black",
                  opacity: 0.7,
                  fontSize: 16,
                  width: "90%",
                  marginTop: 0,
                  opacity: 0.7,
                  marginLeft: 45,
                }}
              >
                YouDub is designed for a wide range of channels, from those
                starting off with 10 subscribers to large channels with millions
                of viewers.
              </p>
            </MDBCol>
            <MDBCol size="4">
              <div
                style={{
                  marginTop: 95,
                  width: "90%",
                  height: 180,
                  marginLeft: "8%",
                  backgroundColor: "white",
                  boxShadow: "0 0 40px 0 rgb(27 6 76 / 10%)",
                }}
              >
                <MDBRow>
                  <MDBCol size="2">
                    <img
                      src={require("./startups.png")}
                      style={{
                        height: 30,
                        width: "auto",
                        marginTop: 30,
                        marginLeft: 40,
                      }}
                    />
                  </MDBCol>
                  <MDBCol size="10">
                    <p
                      style={{
                        fontFamily: "PlusJSExtraBold",
                        fontSize: 18,
                        marginTop: 35,
                        lineHeight: 1.3,
                        width: "100%",
                        marginLeft: 30,
                      }}
                    >
                      Perfect for small channels
                    </p>
                  </MDBCol>
                  <MDBCol size="12">
                    <p
                      style={{
                        fontFamily: "PlusJSMedium",
                        color: "black",
                        opacity: 0.7,
                        fontSize: 14,
                        width: "80%",
                        marginTop: 5,
                        opacity: 0.9,
                        marginLeft: 40,
                      }}
                    >
                      We give discounts to smaller channels getting off the
                      ground to help them find their feet.
                    </p>
                  </MDBCol>
                </MDBRow>
              </div>
            </MDBCol>
            <MDBCol size="4">
              <div
                style={{
                  marginTop: 95,
                  width: "90%",
                  height: 180,
                  backgroundColor: "white",
                  boxShadow: "0 0 40px 0 rgb(27 6 76 / 10%)",
                }}
              >
                <MDBRow>
                  <MDBCol size="2">
                    <img
                      src={require("./enterprise.png")}
                      style={{
                        height: 30,
                        width: "auto",
                        marginTop: 30,
                        marginLeft: 40,
                      }}
                    />
                  </MDBCol>
                  <MDBCol size="10">
                    <p
                      style={{
                        fontFamily: "PlusJSExtraBold",
                        fontSize: 18,
                        marginTop: 35,
                        lineHeight: 1.3,
                        width: "100%",
                        marginLeft: 30,
                      }}
                    >
                      Ready for large channels
                    </p>
                  </MDBCol>
                  <MDBCol size="12">
                    <p
                      style={{
                        fontFamily: "PlusJSMedium",
                        color: "black",
                        opacity: 0.7,
                        fontSize: 14,
                        width: "80%",
                        marginTop: 5,
                        opacity: 0.9,
                        marginLeft: 40,
                      }}
                    >
                      We work alongside you to ensure you can revamp your entire
                      operations for efficient and cheap dubbing.
                    </p>
                  </MDBCol>
                </MDBRow>
              </div>
            </MDBCol>
          </MDBRow>

          <MDBRow>
            <div
              className="pattern2"
              style={{
                height: 400,
                width: "100vw",
                backgroundRepeat: "repeat",
              }}
            >
              <MDBRow>
                <MDBCol className="d-flex justify-content-center" size="12">
                  <p
                    style={{
                      fontFamily: "PlusJSExtraBold",
                      fontSize: 29,
                      color: "black",
                      marginTop: 100,
                      lineHeight: 1.3,
                      width: "100%",
                      textAlign: "center",
                    }}
                  >
                    Ready to start?
                  </p>
                </MDBCol>
                <MDBCol className="d-flex justify-content-center" size="12">
                  <p
                    style={{
                      fontFamily: "PlusJSMedium",
                      color: "black",
                      opacity: 0.7,
                      fontSize: 16,
                      width: "30%",
                      marginTop: 0,
                      textAlign: "center",
                      opacity: 0.7,
                    }}
                  >
                    We work alongside you to ensure you can get started using
                    YouDub in under 10mins.
                  </p>
                </MDBCol>

                <MDBCol className="d-flex justify-content-center" size="12">
                  <a
                    href=""
                    target="_blank"
                    className="d-flex justify-content-center"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    <div
                      className="d-flex  HeroButton lightButton justify-content-center"
                      style={{
                        backgroundColor: "#FF0000",
                        borderRadius: 200,
                        paddingTop: 10,
                        color: "white",
                        fontFamily: "PlusJSBold",
                        fontSize: 17,
                        width: 170,
                        height: 49,
                        marginTop: 10,
                        display: "inline-block",
                      }}
                    >
                      Book a Demo
                    </div>
                  </a>
                </MDBCol>
                <MDBCol className="d-flex justify-content-center" size="12">
                  <p
                    style={{
                      fontFamily: "PlusJSMedium",
                      color: "black",
                      fontSize: 12,
                      marginTop: 5,
                      textAlign: "center",
                      opacity: 1,
                    }}
                  >
                    Have questions?{"  "}
                    <a
                      href="mailto:help@youdub.me"
                      style={{
                        display: "inline-block",
                        textDecoration: "underline",
                        color: "#FF0000",
                      }}
                    >
                      Contact us
                    </a>
                  </p>
                </MDBCol>
              </MDBRow>
            </div>
          </MDBRow>

          <MDBRow
            style={{
              width: "100vw",
              backgroundColor: "#F5F5F5",
              color: "black",
              paddingBottom: "10vh",
            }}
          >
            <FAQ />
          </MDBRow>
        </MDBCol>
        <div className="HeroSection">
          <Footer />
        </div>
      </>
    );
  }
}

export default withRouter(Intro);
